<template>
	<div class="ReInputContact">
		<div  v-for="(objContact, obj_index) in value" :key="obj_index">

			<label class="col-form-label col-md-12 mb-0" style="max-width: 420px;" :class="[{'formRequiredSpec':(contactGroup ==='phone')}, ]"  v-if="(contactGroup != 'web') || !isShown">

				<span v-if="objContact.contact_group != 'phone'">{{ label }} </span>
				<span v-if="objContact.contact_group == 'phone'">{{ label }} (ввести без скобок, пробелов и дефисов; номера РФ с 8, +7)</span>
				<!-- <span v-if="objContact.contact_group == 'phone'">{{ label }} (ввести без скобок, пробелов и дефисов; номера РФ с 8, +7 или с кода оператора)</span> -->
				
			</label>
			<p v-if="!isAttentionNote"> <i class="tim-icons text-danger icon-alert-circle-exc"></i> На сайтах обычно используются подменные номера. Пожалуйста, уточните у клиента личный номер во избежание потери контакта.</p>
			<div v-if="false" class="row mx-0 mb-1">
				<base-checkbox v-if="objContact.contact_group=='phone'" v-model="objContact.contact_foreign" inline>Иностранный номер</base-checkbox>
			</div>
			<div class="row cc-item"  v-if="(contactGroup != 'web')  || !isShown">
				<div class="fieldset col-md-12 d-flex" :class="[{'no-select':(contactGroup == 'email' || contactGroup == 'web')}]" >
					
					<el-select v-if="contactGroup_options.length > 0 && contactGroup != 'email' && contactGroup != 'web'"
							class="select-primary"
							placeholder="Тип Контакта"
							v-model="objContact.contact_type"
							@change="updateGroup(objContact)"
					>
						<el-option
							v-for="(sel_opt, sel_index) in contactGroup_options"
							class="select-primary"
							:value="sel_opt.value"
							:label="sel_opt.label"
							:key="sel_index"
						>
						</el-option>
					</el-select>
					<base-input	v-if="objContact.contact_group=='phone' || objContact.contact_group=='intphone'"
						:name="errorLabel+'_'+obj_index"
						:placeholder="comp_placeholder(objContact.contact_type)"
						:mask="objContact.contact_type==44?'phoneext':(objContact.contact_type==1 || objContact.contact_type==2 || objContact.contact_type==41)?'phone':'messanger'"
						v-validate="objContact.contact_type==40?'messanger':validation[contactGroup]"
						v-model="objContact.contact_value"
						:error="getError(errorLabel+'_'+obj_index)"
						@blur="checkClient(obj_index,0)"
						@keyup="checkClient(obj_index,1)"
						:required="required"
					>
					</base-input>
					<base-input	v-else
						:name="errorLabel+'_'+obj_index"
						:placeholder="comp_placeholder(objContact.contact_type)"
						v-validate="validation[objContact.contact_group]"
						v-model="objContact.contact_value"
						:error="getError(errorLabel+'_'+obj_index)"
						:required="required"
						@blur="checkClient(obj_index,0)"
					>
					</base-input>
					<div class="btnGroup col pr-0 pl-1" v-if="(contactGroup == 'phone' && bShowCallBtn == true && lead_id !='' && lead_id !='undefined')">
						<RePhoneCallButton
							:phone="objContact.contact_value"
							:lead_id="lead_id"
							:beforeCall="beforeCall"
						/>
					</div>
					<div class="btnGroup col pr-0 pl-1">
						<button class="btn btn-icon btn-simple btn-danger mt-0" @click="delContact(obj_index)">
							<i class="tim-icons icon-trash-simple"></i>
						</button>
					</div>
				</div>
				
			</div>

			<label v-if="(contactGroup_options.length > 0 && contactGroup == 'phone' && copyFrom != '')" class="mb-0">Скопируйте текущий контакт в мессенджер: </label>
			<div class="success-copy" v-if="opacityOn"><span  class="text-success"> Контакт добавлен в мессенджеры!</span></div>
			<div v-if="(contactGroup_options.length > 0 && contactGroup == 'phone' && copyFrom != '')">
				<base-button class="btn btn-icon btn-simple btn-primary mr-2" @click="copyPhoneContact('40', obj_index)" :class="[{'messicon-bg':value.contact_type=='40'}]">
					<i class="messicon messicon-telegram"></i>
				</base-button>
				<base-button class="btn btn-icon btn-simple btn-success mr-2" @click="copyPhoneContact('41', obj_index)" :class="[{'messicon-bg':contactGroup_options.value=='41'}]">
					<i class="messicon messicon-whatsapp"></i>
				</base-button>
				
				<base-button v-if="false" class="btn btn-icon btn-simple btn-info mr-2" @click="copyPhoneContact('42', obj_index)" :class="[{'messicon-bg':contactGroup_options.value=='42'}]">
					<i class="messicon messicon-viber"></i>
				</base-button>				
			</div>
		</div>
		<div v-if="bClientExists" class="clientExists mb-2">
			<div class="text-warning mr-2">Такой клиент уже есть</div>
				<!-- <a href="#" @click="Go2Client(objClient)" :key="objClient.id"> перейти в основного клиента (id: {{objClient.root_id}})</a> -->

			<template v-if="!isCallCenter">
				<template v-for="objClient in masClientExists">
					<template v-if="objClient.root_id == 0">
						<a class="mr-2" href="#" @click="Go2Client(objClient)" :key="objClient.id"> перейти в основного клиента ID {{ objClient.id }}</a>
					</template>
				</template>
			</template>
			<!--
			<template v-else>
				<span>{{ isCallCenter }}</span>
			</template>
			-->
			<!-- <template v-for="objClient in masClientExists">
				<a href="#" @click="Go2Client(objClient)" :key="objClient.id">{{objClient.fio}}</a>
			</template> -->
		</div>
		<template v-if="bShowAddBtn">
			<button class="btn btn-simple btn-primary" @click="addEmptyContact()" v-if="(contactGroup != 'web') || !isShown">
				Добавить контакт
			</button>
		</template>
		
	</div>
</template>

<script>
	import {Select, Option} from 'element-ui';
	import RePhoneCallButton from "src/our_components/RePhoneCallButton.vue";
	import { BaseCheckbox } from 'src/components/index';

	export default {
		name: 'ReInputContact',
		components: {
			[Option.name]: Option,
        	[Select.name]: Select,
			RePhoneCallButton,
			BaseCheckbox,
		},
		props: {
			value: {
				type: Array,
				default(){return [{
					contact_id: '',
					contact_type: '',
					contact_value: '',
					contact_view: '',
					contact_foreign: false,
				}];}
			},
			contactGroup: String,
			contactGroup_options:{
				type: Array,
				default(){return [];}
			},
			delMethod:{
				type: Object,
				default(){return {};}
			},
			placeholder: [String, Object],
			required:{
				type: Boolean,
				default: false
			},
			errorLabel: String,
			label: String,
			bShowView:{
				type: Boolean,
				default: true
			},
			bShowCallBtn:{
				type: Boolean,
				default: false
			},
			copyFrom: {
				type: String,
				default: ''
			},
			isCallCenter:{
				type: Boolean,
				default: false
			},
			saveClientFio:{
				type: Boolean,
				default: false
			},
			bShowAddBtn:{
				type: Boolean,
				default: true
			},
			bCheckClient:{
				type: Boolean,
				default: true
			},
			beforeCall:{
				type: Function,
				required: false,
			}			

		},
		data () {
			return {
				ver: 1,
				masContacts:[],
				validation:{
					required: {
						required: true
						// required: this.ruContact()
					},
					email:{
						email: true
					},
					phone:{
						//regex: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,15}$/,
						regex: /^((\d|\+\d)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,15}$/,
					},
					// phoneForeign:{
					// 	regex: '',
					// },
					web:{
						url: {require_protocol: true }
					},
					messanger:{
						min: 3
					},
					social:{
						url: {require_protocol: true }
					},
				},
				bClientExists: false,
				masClientExists: [],
				idClientExists: -1,
				iValueClientExists: -1,
				isShown: true,
				isAttentionNote: true,
				opacityOn: false,
				lead_id:'',
				lastCheckPhone:'',
				contactValues: this.value.map(item => item.contact_value)
			}
		},
		computed: {
			
			
		},
		methods: {
			updateGroup(contact){
				let group = this.contactGroup_options.find(r=>r.value==contact.contact_type);
				if(group.group) this.$set(contact,'contact_group',group.group);
				// console.log(contact, contact.contact_type, group, this.contactGroup_options);
			},
			ruContact(value){
				if(value == undefined || value == ''){
					// console.log(true);
					return true;
				}
				else if((value.startsWith('+7') || value.startsWith('8') || value.startsWith('7')) && !value.startsWith('+77')){
					// +77 -- Казахстан 
					//return '';
					// console.log(true);
					return true;
				} else {
					//return  /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/;
					// console.log(false);
					return false;
					
				}
				
			},
			addEmptyContact(){
				let singleType = '';
				if(this.contactGroup == 'email' || this.contactGroup == 'web'){
					singleType = this.contactGroup_options[0].value;
				}
				if(this.contactGroup == 'phone'){
					singleType = '1';
				}
				this.value.push({
					contact_id: '',
					contact_type: singleType,
					contact_value: '',
					contact_view: '',
					contact_group: this.contactGroup,
					contact_foreign: false
				});
				this.contactValues.push('');
			},
			opacityOnSwitch() {
				this.opacityOn = true;
				setTimeout(() => {
					this.opacityOn = false;
				}, 2500)
			},
			copyPhoneContact(msgType, obj_index){
				if(this.copyFrom != '' && typeof this.value[obj_index].contact_value != 'undefined' && this.value[obj_index].contact_value != ''){
					if(typeof this.$parent.opt.elements != 'undefined'){
						for (let iOpt = 0; iOpt < this.$parent.opt.elements.length; iOpt++) {
							const element = this.$parent.opt.elements[iOpt];
							if(typeof element.contactGroup != 'undefined'){
								if(element.elementGetParamMap == this.copyFrom && element.contactGroup=='messanger'){
									let bInsert = true;
									for (let iEl = 0; iEl < element.element_model.length; iEl++) {
										if (element.element_model[iEl].contact_value == this.value[obj_index].contact_value && element.element_model[iEl].contact_type == msgType) {
											bInsert = false;
										}
									}
									if(bInsert){
										element.element_model.push({
											contact_id: '',
											contact_type: msgType,
											contact_value: this.$GVO.unlinkObject(this.value[obj_index].contact_value),
											contact_view: '',
											contact_group: 'messanger',
										});
										this.opacityOnSwitch();
									}
								}
							}
						}
					}
				}
			},
			delContact(ind){
				if(this.value[ind].contact_id != ''){
					if(!this.$GVO.isEmpty(this.delMethod)){
						let apiParam = this.delMethod.apiParam;
						if(apiParam.obj == 'staff'){
							apiParam.flt.code=this.$route.params.code;
							apiParam.flt.contact_id=this.value[ind].contact_id;
						}
						if(apiParam.obj == 'client'){
							// if(this.value[ind].contact_group=='phone' && this.value.length ==1){
							// 	console.log("You cannot delete last contact");								
							// 	apiParam = '';
							// } else {
							// 	apiParam.flt.id=this.$route.params.client_id;
							// 	apiParam.flt.contact_id=this.value[ind].contact_id;
							// }
							apiParam.flt.id=this.$route.params.client_id;
							apiParam.flt.contact_id=this.value[ind].contact_id;
						}
						this.$GVO.ApiCall(this.delMethod.apiMethod,apiParam)
							.then((objApi) => {  /*console.log(objApi); console.log('УСПЕШНОЕ УДАЛЕНИЕ КОНТАКТА');*/ })
							.catch((errorObjApi) => {console.error(errorObjApi)});
					}
				}
				this.value.splice(ind,1);
				this.contactValues.splice(ind,1);
			},
			applyView(ind,viewType){
				this.value[ind].contact_view = viewType;
			},
			getError(fieldName) {
				return this.errors.first(fieldName);
			},
			comp_placeholder(strType){
				if(typeof this.placeholder == 'object'){
					if(strType !=''){
						for (let i = 0; i < this.contactGroup_options.length; i++) {
							if(this.contactGroup_options[i].value == strType){
								return this.placeholder[this.contactGroup_options[i].label];
							}							
						}
					}else{
						return 'Введите ...';
					}
				}
				return this.placeholder;
			},
			checkClient(obj_index,type){
				// this.bClientExists = false;
				// console.log(type, this.value[obj_index].contact_value, this.lastCheckPhone, this.bCheckClient);
				if(this.bCheckClient == false)return true;
				// console.log(this.value[obj_index].contact_value == this.contactValues[obj_index]);
				if(this.value[obj_index].contact_value == this.contactValues[obj_index])return true;
				this.value[obj_index].contact_value = this.$GVO.trim(this.value[obj_index].contact_value);
				if(type!=1 || (type==1 && this.value[obj_index].contact_value.length>9) ){
					// console.log(this.value[obj_index].contact_value);
					if(/*this.value[obj_index].contact_group=='phone' &&*/ this.value[obj_index].contact_value !=''){
						// console.log(this.lastCheckPhone != this.value[obj_index].contact_value);
						if(this.lastCheckPhone != this.value[obj_index].contact_value){
							this.lastCheckPhone = this.value[obj_index].contact_value;
							this.contactValues[obj_index] = this.value[obj_index].contact_value;
							if(this.saveClientFio){this.$set(this.value[obj_index],'client',{ })};
																
							this.$GVO.ApiCall('GET_CLIENTFIND',{obj:'client',flt:{contact_value:this.value[obj_index].contact_value}})
							.then((objApi) => {
								// console.log('checkClient',objApi);
								if(objApi.success === true && typeof objApi.data[0] != 'undefined'){
									this.bClientExists = true;
									this.masClientExists = objApi.data;
									//this.idClientExists = objApi.data[0].id;
									this.iValueClientExists = this.value[obj_index].contact_value;
									if(this.saveClientFio && this.masClientExists[0]){
										this.$set(this.value[obj_index],'client',{
											name: this.masClientExists[0].name,
											surname: this.masClientExists[0].surname,
											patronymic: this.masClientExists[0].patronymic,
										})
									}
								}else{
									this.bClientExists = false;
									this.masClientExists=[];

								}
							}).catch(errorObjApi => console.error(errorObjApi));
						}
					}
				}
			},
			Go2Client(objClient){
				if(typeof objClient != 'undefined'){
					this.$GVO.ApiCall('ADD_CLIENT_OWNER',{obj:'client',flt:{'client_id':objClient.id,'client_contact_value':this.iValueClientExists},iData:{'agent_code':this.$GVO.my_profile.code}})
					.then((objApi) => {
						//console.log(objApi);
						if(objApi.success){
							
						}
						location.href = '/data/clients/id/'+objClient.id;
					})
					.catch(errorObjApi => {console.error(errorObjApi); });

				}
			},
			getLeadID(){
				this.lead_id = typeof this.$route.params.lead_id == 'undefined'?'0':this.$route.params.lead_id;
			},
		},
		created(){
			if(location.pathname.indexOf('/data/clients/add') != -1){this.isShown = true;} else {this.isShown = false;}
			if(location.pathname.indexOf('/data/ColdCall/id') != -1){this.isAttentionNote = false;} else {this.isAttentionNote = true;}
		},
		mounted(){
			if(location.pathname.indexOf('/data/callcenter/id/') != -2 || location.pathname.indexOf('/data/callcenter/add') != -1){
				// console.log(location.pathname);
				this.getLeadID();
			}else {}
			// this.ruContact();
			// console.log(this.ruContact());
			if(this.contactGroup_options.length==1 && this.value[0].contact_type==''){
				this.value[0].contact_type = this.contactGroup_options[0].value;
			}
		},
	}
</script>
<style scoped>
	.ReInputContact .fieldset{
		display: flex;
		justify-content: flex-start;
		/* align-items: center; */
	}
	.ReInputContact .fieldset > *{
		width: 100%; 
		margin-bottom: 0px;
	}
	.ReInputContact .fieldset:not(.no-select) > div:nth-child(1){width: 250px;}
	.ReInputContact .btnGroup{
		display: flex;
		align-items: center;
	}
	.cc-item{
		margin-bottom: 15px;
	}
	.ReInputContact >>> .el-input__inner {font-size: 0.75rem;}
	.ReInputContact >>> .fieldset > div:nth-child(2) .form-control {height: 38px;}

	.clientExists > *{display: block;}
	.clientExists {display: flex; flex-wrap: wrap;}
	.messicon {
		width: 18px;
		height: 18px;
		display: inline-block;
	}
	.messicon-bg {background:#044c60;}
	.messicon-telegram {background: url('/img/icons/telegramlogo.svg') no-repeat; }
	.messicon-whatsapp {background: url('/img/icons/whatsapplogo.svg') no-repeat; }
	.messicon-viber {background: url('/img/icons/viberlogo.svg') no-repeat; }
	.success-copy {height: 1.3rem;}


	/* .messicon-skype {background: url('/img/icons/skypelogo.svg') no-repeat; } */

	/*
	Этот код вынесен в src/assets/sass/dashboard/custom/_global.scss т.к. там работает, а тут нет - хз почему
	.ReInputContact .fieldset > div:nth-child(2) .form-control{height:40px;}
	.ReInputContact .fieldset:not(.no-select) > div:nth-child(1) input{
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}
	.ReInputContact .fieldset > div:nth-child(2) input{
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}
	.ReInputContact .btnGroup .btn.dropdown-toggle[data-toggle="dropdown"]{margin-bottom: 0px !important;}
	*/
</style>
